import { render, staticRenderFns } from "./TaskDetailTab.vue?vue&type=template&id=1b92a5a6&scoped=true&"
import script from "./TaskDetailTab.vue?vue&type=script&lang=js&"
export * from "./TaskDetailTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b92a5a6",
  null
  
)

export default component.exports